import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { MatDialog } from "@angular/material/dialog";
import { JoiningInterestDetailsComponent } from "../new-v2-component/joining-interest-details/joining-interest-details.component";
import { CreateNewBookingComponent } from "src/app/shared/components/create-new-booking/create-new-booking.component";
import { AddJoiningInterestComponent } from "../new-v2-component/add-joining-interest/add-joining-interest.component";
import { UpdateInterestStatusReplyComponent } from "../new-v2-component/update-interest-status-reply/update-interest-status-reply.component";
import { AddJoiningQueryComponent } from "../new-v2-component/add-joining-query/add-joining-query.component";
import { CreateInvoiceForFitnessComponent } from "src/app/shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { AssignJobComponent } from "src/app/shared/components/assign-job/assign-job.component";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { CustomiseBookingComponent } from "src/app/shared/components/customise-booking/customise-booking.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { ManageBookingComponent } from "src/app/shared/components/manage-booking/manage-booking.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { AttendanceMarkerComponent } from "../new-v2-component/attendance-marker/attendance-marker.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { AuthService } from "src/app/providers/auth.service";
import { AssignJobForMembersComponent } from "src/app/shared/components/assign-job-for-members/assign-job-for-members.component";
import { BookingDetailsForMemberComponent } from "src/app/shared/components/booking-details-for-member/booking-details-for-member.component";
import { MeetingDataForAppointmentComponent } from "../new-v2-component/meeting-data-for-appointment/meeting-data-for-appointment.component";
import { CreateNewBookingFromListComponent } from "src/app/shared/components/create-new-booking-from-list/create-new-booking-from-list.component";
import { AddJoiningInterestFromListComponent } from "../new-v2-component/add-joining-interest-from-list/add-joining-interest-from-list.component";

@Component({
  selector: "sm-joining-query-list",
  templateUrl: "./joining-query-list.component.html",
  styleUrls: ["./joining-query-list.component.scss"],
})
export class JoiningQueryListComponent implements OnInit, OnDestroy {
  isAccessForEmployeeInvoice: boolean = false;

  messageList: any = [];
  attendanceList: any = [];
  processType: number = 2; //1 = query, 2 = booking
  selectedValue: string = "0";
  fromDate: any = new Date();
  toDate: any = new Date();
  loader: boolean = false;
  interestData: any = [];
  interestStatus: string = "1";
  apisub: Subscription;
  @ViewChild("costTemplate", { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  bookingsData: any[] = [];
  discountInfo: any = null;
  displayedColumns: string[] = [
    "date",
    "customerName",
    "noOfServices",
    "cost",
    "paymentStatus",
    "startTime",
    "endTime",
    "assignedTo",
    "bookingType",
    "bookingStatus",
    "actions",
  ];
  queryData: any = [];
  tableDisplayColumnsforserviceQuery: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },

    {
      columnName: "service mode",
      columnProperty: "s_mode",
    },
    {
      columnName: "Enquiry type",
      columnProperty: "e_type",
    },
    {
      columnName: "status",
      columnProperty: "item_status",
    },
  ];
  tableDisplayColumnsForBookings: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.booking_no"
      ),
      columnProperty: "appointment_no",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.customer_name"
      ),
      columnProperty: "cust_name",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.customer_phone"
      ),
      columnProperty: "cust_phn",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.services"
      ),
      columnProperty: "servicesArray",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.cost"
      ),
      columnProperty: "costing",
      columnTemplate: this.costTemplateRef,
    },

    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.payment_status"
      ),
      columnProperty: "paymentStat",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.start_time"
      ),
      columnProperty: "bookingStartTime",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.end_time"
      ),
      columnProperty: "bookingEndTime",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.assigned_to"
      ),
      columnProperty: "employeeName",
    },
    {
      columnName: this.translateService.instant(
        "business_bookings.column_headers.booking_status"
      ),
      columnProperty: "bookingStat",
    },
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "customer name",
      columnProperty: "customer_name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
    {
      columnName: "opted services",
      columnProperty: "opted_services",
    },
    {
      columnName: "opted timings",
      columnProperty: "opted_timings",
    },
    {
      columnName: "status",
      columnProperty: "item_status",
    },
    // {
    //   columnName: 'customer notes',
    //   columnProperty: "customer_notes",
    // },
    // {
    //   columnName: 'entity reply',
    //   columnProperty: "entity_reply",
    // },
  ];
  constructor(
    private translateService: TranslateService,
    private navservice: NavigationService,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private zone: NgZone
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForNewQueries();
    this.listenForNewQueriesStatusUpdate();
    this.listenForMemberAttendance();
    this.listenForMemberBookingStatusUpdate();
    this.listenForMemberBookingAssignmentUpdates();
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID
      ) {
        this.interestData = [];
        if (resdata.result) {
          this.interestData = resdata.result;
          console.log(this.interestData);

          this.interestData.forEach((element: any) => {
            element.request_services =
              typeof element.request_services == "string"
                ? JSON.parse(element.request_services)
                : element.request_services;
            element.custom_items =
              typeof element.custom_items == "string"
                ? JSON.parse(element.custom_items)
                : element.custom_items;
            element.products =
              typeof element.products == "string"
                ? JSON.parse(element.products)
                : element.products;
            element.request_timings =
              typeof element.request_timings == "string"
                ? JSON.parse(element.request_timings)
                : element.request_timings;
            element.phone =
              element.customer_country_code + " " + element.customer_phone;

            if (element.interest_type == 0) {
              element.service_mode = "Home service";
            } else if (element.interest_type == 1) {
              element.service_mode = "In-premise service";
            } else if (element.interest_type == 2) {
              element.service_mode = "Virtual service";
            }

            if (element.enrollment_request_status == 1) {
              element.item_status = "New";
            } else if (element.enrollment_request_status == 2) {
              element.item_status = "In progress";
            } else if (element.enrollment_request_status == 3) {
              element.item_status = "Marked as enrolled";
            } else if (element.enrollment_request_status == 4) {
              element.item_status = "Cancelled";
            } else if (element.enrollment_request_status == 5) {
              element.item_status = "Enrolled";
            }

            element.opted_services = element.request_services
              ? this.getServiceNames(element.request_services)
              : "";
            element.opted_timings = element.request_timings
              ? this.formatSchedule(element.request_timings)
              : "";
          });
          if (this.interestType == "4") {
            this.tableDisplayColumns = [
              {
                columnName: "customer name",
                columnProperty: "customer_name",
              },
              {
                columnName: "phone",
                columnProperty: "phone",
              },
              {
                columnName: "service mode",
                columnProperty: "service_mode",
              },
              {
                columnName: "opted services",
                columnProperty: "opted_services",
              },
              {
                columnName: "opted timings",
                columnProperty: "opted_timings",
              },
              // {
              //   columnName: 'customer notes',
              //   columnProperty: "customer_notes",
              // },
              // {
              //   columnName: 'entity reply',
              //   columnProperty: "entity_reply",
              // },
              {
                columnName: "status",
                columnProperty: "item_status",
              },
            ];
          }
        }
        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_SEARCH_BY_ENROLL_INTEREST
      ) {
        this.interestData = [];
        if (resdata.result) {
          this.interestData = resdata.result;
          console.log(this.interestData);

          this.interestData.forEach((element: any) => {
            element.request_services =
              typeof element.request_services == "string"
                ? JSON.parse(element.request_services)
                : element.request_services;
            element.custom_items =
              typeof element.custom_items == "string"
                ? JSON.parse(element.custom_items)
                : element.custom_items;
            element.products =
              typeof element.products == "string"
                ? JSON.parse(element.products)
                : element.products;
            element.request_timings =
              typeof element.request_timings == "string"
                ? JSON.parse(element.request_timings)
                : element.request_timings;
            element.phone =
              element.customer_country_code + " " + element.customer_phone;

            if (element.interest_type == 0) {
              element.service_mode = "Home service";
            } else if (element.interest_type == 1) {
              element.service_mode = "In-premise service";
            } else if (element.interest_type == 2) {
              element.service_mode = "Virtual service";
            }

            if (element.enrollment_request_status == 1) {
              element.item_status = "New";
            } else if (element.enrollment_request_status == 2) {
              element.item_status = "In progress";
            } else if (element.enrollment_request_status == 3) {
              element.item_status = "Marked as enrolled";
            } else if (element.enrollment_request_status == 4) {
              element.item_status = "Cancelled";
            } else if (element.enrollment_request_status == 5) {
              element.item_status = "Enrolled";
            }

            element.opted_services = element.request_services
              ? this.getServiceNames(element.request_services)
              : "";
            element.opted_timings = element.request_timings
              ? this.formatSchedule(element.request_timings)
              : "";
          });
        }
        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_LIST
      ) {
        this.queryData = [];
        if (resdata.result) {
          this.queryData = resdata.result;
          console.log(this.queryData);

          this.queryData.forEach((element: any) => {
            element.phone = element?.country_code + " " + element.phone;
            element.email = element.email ?? "";

            if (element.service_mode == 0) {
              element.s_mode = "Home service";
            } else if (element.service_mode == 1) {
              element.s_mode = "In-premise service";
            } else if (element.service_mode == 2) {
              element.s_mode = "Virtual service";
            }

            if (element.status == 1) {
              element.item_status = "New";
            } else if (element.status == 2) {
              element.item_status = "In progress";
            } else if (element.status == 3) {
              element.item_status = "Resolved";
            } else {
              element.item_status = "---";
            }

            if (element.enquiry_type == 1) {
              element.e_type = "Booking";
            } else if (element.enquiry_type == 2) {
              element.e_type = "Membership";
            } else if (element.enquiry_type == 3) {
              element.e_type = "Payment";
            } else if (element.enquiry_type == 4) {
              element.e_type = "Feedback";
            } else if (element.enquiry_type == 5) {
              element.e_type = "Others";
            }
          });
        }
        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS
      ) {
        if (resdata.result) {
          if (this.currentStatusOfChange == 3) {
            this.loaderservice.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Success !",
                message:
                  "The status changed to Enrolled is successfully done. Do you want to add this person as a member now?",
                cancelbtn: "I'll do later",
                okbtn: "Add as member",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((res) => {
              if (res) {
                let data = {
                  entityHash: this.entityHash,
                  memberData: this.currentMemberOfChange,
                  // serviceType: this.interestType,
                };

                let dialogref = this.dialog.open(AddMemberComponent, {
                  width: "650px",
                  data: {
                    title: "Add member",
                    ref: this.dialog,
                    data: data,
                  },
                });
                dialogref.afterClosed().subscribe((res) => {
                  if (res) {
                    if (res.errorcode == 1) {
                      this.loaderservice.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else if (res.errorcode == 2) {
                      this.loaderservice.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else {
                      // this.loader = true
                      this.loaderservice.showLoader = true;
                      this.apiservice.getAllEnrollInterestByEntityId(
                        this.entityHash,
                        this.interestStatus,
                        this.formatDate1(this.fromDate),
                        this.formatDate1(this.toDate),
                        this.pageNo.toString(),
                        this.interestType
                      );
                    }
                  } else {
                    this.loaderservice.showLoader = true;
                    this.apiservice.getAllEnrollInterestByEntityId(
                      this.entityHash,
                      this.interestStatus,
                      this.formatDate1(this.fromDate),
                      this.formatDate1(this.toDate),
                      this.pageNo.toString(),
                      this.interestType
                    );
                  }
                });
              } else {
                this.loaderservice.showLoader = true;
                this.apiservice.getAllEnrollInterestByEntityId(
                  this.entityHash,
                  this.interestStatus,
                  this.formatDate1(this.fromDate),
                  this.formatDate1(this.toDate),
                  this.pageNo.toString(),
                  this.interestType
                );
              }
            });
          } else {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.entityHash,
              this.interestStatus,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              this.interestType
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_REQUEST_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getAllEnrollInterestByEntityId(
            this.entityHash,
            this.interestStatus,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            this.pageNo.toString(),
            this.interestType
          );
        }
      }

      // BOOKING OPERATIONS SUBSCRIPTIONS
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_BOOKINGS_FOR_FITNESS_ENTITY
      ) {
        console.log(resdata);
        this.bookingsData = resdata.result ? resdata.result : [];
        // this.bookingsData = this.sortObjectsDescendingByBookingNumber(this.bookingsData)

        this.bookingsData.forEach((element: any) => {
          if (element.data_type == 1) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name;
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.servicesArray.push(" " + item.serviceName);
                });
              }
            }
            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }
            if (element.appointment_products) {
              if (element.appointment_products != null) {
                element.appointment_products =
                  typeof element.appointment_products == "string"
                    ? JSON.parse(element.appointment_products)
                    : element.appointment_products;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }

            element.costing = element.currency_symbol
              ? element.currency_symbol + element.price
              : "₹" + element.price;

            if (element.customer_name == "null" || !element.customer_name) {
              element.cust_name = "New Customer";
            } else if (
              element.customer_name != "null" ||
              element.customer_name
            ) {
              element.cust_name = element.customer_name;
            }

            if (element.customer_phone == "null" || !element.customer_phone) {
              element.cust_phn = "---";
            } else if (
              element.customer_phone != "null" ||
              element.customer_phone
            ) {
              element.cust_phn =
                element.country_code + " " + element.customer_phone;
            }

            if (element.paymentStatus === 0 || !element.paymentStatus) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.bookingStatus == 0 ||
              element.bookingStatus == 1 ||
              element.bookingStatus == 2
            ) {
              element.bookingStat = "New booking";
            } else if (element.bookingStatus == 3) {
              element.bookingStat = "Under process";
            } else if (element.bookingStatus == 4) {
              element.bookingStat = "Completed";
            } else if (element.bookingStatus == 5) {
              element.bookingStat = "Booking confirmed";
            } else if (element.bookingStatus == 6) {
              element.bookingStat = "Cancelled by User";
            } else if (element.bookingStatus == 7) {
              element.bookingStat = "Assigned";
            } else if (element.bookingStatus == 8) {
              element.bookingStat = "Cancelled";
            } else if (element.bookingStatus == 9) {
              element.bookingStat = "Partially Complete";
            }

            if (!element.employeeName) {
              element.employeeName = "---";
            }
          }
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name;
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.servicesArray.push(" " + item.service_name);
                });
              }
            }
            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.custom_items.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }
            if (element.appointment_products) {
              if (element.appointment_products != null) {
                element.appointment_products =
                  typeof element.appointment_products == "string"
                    ? JSON.parse(element.appointment_products)
                    : element.appointment_products;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }
            if (element.enrolled_member_timings) {
              if (element.enrolled_member_timings != null) {
                element.enrolled_member_timings =
                  typeof element.enrolled_member_timings == "string"
                    ? JSON.parse(element.enrolled_member_timings)
                    : element.enrolled_member_timings;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }

            element.appointment_no = "---";
            element.costing = element.currency_symbol
              ? element.currency_symbol + element.price
              : "₹" + element.price;
            //  element.servicesArray = [element.serviceInfo]
            element.paymentStat = "---";
            if (element.customer_name == "null" || !element.customer_name) {
              element.cust_name = "New Customer";
            } else if (
              element.customer_name != "null" ||
              element.customer_name
            ) {
              element.cust_name = element.customer_name;
            }

            if (element.customer_phone == "null" || !element.customer_phone) {
              element.cust_phn = "---";
            } else if (
              element.customer_phone != "null" ||
              element.customer_phone
            ) {
              element.cust_phn =
                element.country_code + " " + element.customer_phone;
            }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.session_start_time &&
              element.session_start_time != null
            ) {
              element.bookingStartTime = element.session_start_time.slice(0, 5);
            }
            if (element.session_end_time && element.session_end_time != null) {
              element.bookingEndTime = element.session_end_time.slice(0, 5);
            }

            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }

            if (!element.employeeName) {
              element.employeeName = "---";
            }
          }
        });

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );

        console.log(this.bookingsData);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MEMBER_SESSION
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (this.selectedValue == "0") {
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date()),
            this.bookingType
          );
        } else if (this.selectedValue == "1") {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date(tomorrow)),
            this.bookingType
          );
        }
        // alert("Invoice generated")
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RESET_BOOKING_DETAILS
      ) {
        if (this.selectedValue == "0") {
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date()),
            this.bookingType
          );
        } else if (this.selectedValue == "1") {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date(tomorrow)),
            this.bookingType
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        if (this.selectedValue == "0") {
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date()),
            this.bookingType
          );
        } else if (this.selectedValue == "1") {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          this.apiservice.getBookingsForFitnessEntity(
            this.entityHash,
            this.formatDateForApi(new Date(tomorrow)),
            this.bookingType
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.entityHash,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else {
            this.apiservice.getHistoricAttendanceListForFitnessEntity(
              this.entityHash,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.entityHash,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else {
            this.apiservice.getHistoricAttendanceListForFitnessEntity(
              this.entityHash,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resdata.result) {
          if (this.processType == 2) {
            if (this.selectedValue == "0") {
              this.apiservice.getBookingsForFitnessEntity(
                this.entityHash,
                this.formatDateForApi(new Date()),
                this.bookingType
              );
            } else if (this.selectedValue == "1") {
              const tomorrow = new Date();
              tomorrow.setDate(tomorrow.getDate() + 1);
              this.apiservice.getBookingsForFitnessEntity(
                this.entityHash,
                this.formatDateForApi(new Date(tomorrow)),
                this.bookingType
              );
            }
          } else if (this.processType == 3) {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.entityHash,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }

      // BOOKING HISTORY

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY
      ) {
        console.log(resdata);
        this.messageList = resdata.result ? resdata.result : [];
        //     this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        //     ((+new Date(dataB['bookingDate'])) - (+new
        //     Date(dataA['bookingDate'])))

        //  )
        // this.messageList = this.sortObjectsDescendingByBookingDate(this.messageList)
        this.messageList.forEach((element: any) => {
          if (element.data_type == 1) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesCount = element.serviceInfo.length;
              }
            }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.bookingStatus == 0 ||
              element.bookingStatus == 1 ||
              element.bookingStatus == 2
            ) {
              element.bookingStat = "New booking";
            } else if (element.bookingStatus == 3) {
              element.bookingStat = "Under process";
            } else if (element.bookingStatus == 4) {
              element.bookingStat = "Completed";
            } else if (element.bookingStatus == 5) {
              element.bookingStat = "Booking confirmed";
            } else if (element.bookingStatus == 6) {
              element.bookingStat = "Cancelled by User";
            } else if (element.bookingStatus == 7) {
              element.bookingStat = "Assigned";
            } else if (element.bookingStatus == 8) {
              element.bookingStat = "Cancelled";
            } else if (element.bookingStatus == 9) {
              element.bookingStat = "Partially Complete";
            }

            const currentDate = new Date();
            const newDate = new Date(currentDate.toISOString().slice(0, 10));
            const bookingDate = new Date(element.bookingDate);
            console.log(bookingDate >= newDate);

            if (bookingDate >= newDate) {
              element.toshowOptions = 1;
            } else {
              element.toshowOptions = 0;
            }
          }
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }
            element.servicesCount = element.serviceInfo.split(",").length;

            element.price = element.price;
            // element.employeeName = "---";
            //   if(element.serviceInfo){
            //    if(element.serviceInfo!= null){
            //     element.serviceInfo = typeof element.serviceInfo == 'string' ? JSON.parse(element.serviceInfo) : element.serviceInfo
            //      element.servicesCount = element.serviceInfo.length
            //    }
            //  }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            } else {
              element.booking_type = "---";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            } else {
              element.bookingStartTime = "---";
            }

            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            } else {
              element.bookingEndTime = "---";
            }

            // if (element.bookingStatus == 0) {
            //   element.bookingStat = "Absent";
            // } else if (element.bookingStatus == 1) {
            //   element.bookingStat = "Present";
            // } else {
            //   element.bookingStat = "---";
            // }
            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }
            //  const currentDate = new Date();
            //  const newDate = new Date(currentDate.toISOString().slice(0,10))
            //  const bookingDate = new Date(element.bookingDate)
            //  console.log(bookingDate >= newDate);

            //  if (bookingDate >= newDate) {
            //      element.toshowOptions = 1
            //  } else {
            //    element.toshowOptions = 0
            //  }
          }
        });

        console.log(this.messageList);

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY
      ) {
        console.log(resdata);
        this.attendanceList = resdata.result ? resdata.result : [];
        //     this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        //     ((+new Date(dataB['bookingDate'])) - (+new
        //     Date(dataA['bookingDate'])))

        //  )
        // this.messageList = this.sortObjectsDescendingByBookingDate(this.messageList)
        this.attendanceList.forEach((element: any) => {
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }
            element.servicesCount = element.serviceInfo.split(",").length;

            element.price = element.price;
            // element.employeeName = "---";
            //   if(element.serviceInfo){
            //    if(element.serviceInfo!= null){
            //     element.serviceInfo = typeof element.serviceInfo == 'string' ? JSON.parse(element.serviceInfo) : element.serviceInfo
            //      element.servicesCount = element.serviceInfo.length
            //    }
            //  }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            } else {
              element.booking_type = "---";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            } else {
              element.bookingStartTime = "---";
            }

            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            } else {
              element.bookingEndTime = "---";
            }

            // if (element.bookingStatus == 0) {
            //   element.bookingStat = "Absent";
            // } else if (element.bookingStatus == 1) {
            //   element.bookingStat = "Present";
            // } else {
            //   element.bookingStat = "---";
            // }
            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }
            //  const currentDate = new Date();
            //  const newDate = new Date(currentDate.toISOString().slice(0,10))
            //  const bookingDate = new Date(element.bookingDate)
            //  console.log(bookingDate >= newDate);

            //  if (bookingDate >= newDate) {
            //      element.toshowOptions = 1
            //  } else {
            //    element.toshowOptions = 0
            //  }
          }
        });

        console.log(this.attendanceList);

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
    });
  }
  entityHash: any;
  eph: any;
  interestType: any;
  pageNo: number = 1;
  bookingType: string = "";
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.route.queryParams.subscribe((res) => {
      this.entityHash = res.entityHash;
      this.eph = res.eph;
      this.interestType = res.serviceType;
      this.bookingType = res.serviceType;
    });
    if (this.isOwner) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss != "2") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.toDate.setDate(this.fromDate.getDate() + 90);
    if (this.bookingType == "4") {
      this.selectedValue = "3";
      this.processType = 3;
      this.fromDate = new Date();
      this.toDate = new Date();
      // this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getHistoricAttendanceListForFitnessEntity(
        this.entityHash,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else {
      this.apiservice.getBookingsForFitnessEntity(
        this.entityHash,
        this.formatDateForApi(new Date()),
        this.bookingType
      );
    }
  }

  firstTimeBelow3: boolean = false;
  searchString: any;
  searchNameData() {
    if (this.searchString.length >= 3) {
      this.firstTimeBelow3 = true;
      this.apiservice.getSearchByEnrollInterest(
        this.entityHash,
        this.searchString
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.apiservice.getAllEnrollInterestByEntityId(
          this.entityHash,
          this.interestStatus,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          this.interestType
        );
      }
    }
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/y9jYlBqYszM",
        title: "Creating Bookings/Appointments in LookzUp Business Portal.",
      },
    });
  }

  openVideoForAttendance() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/EFIB81ov0ts",
        title: "Creating Bookings/Appointments in LookzUp Business Portal.",
      },
    });
  }

  refresh() {
    this.loaderservice.showLoader = true;
    if (this.selectedValue == "0") {
      this.apiservice.getBookingsForFitnessEntity(
        this.entityHash,
        this.formatDateForApi(new Date()),
        this.bookingType
      );
    } else if (this.selectedValue == "1") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.apiservice.getBookingsForFitnessEntity(
        this.entityHash,
        this.formatDateForApi(new Date(tomorrow)),
        this.bookingType
      );
    } else if (this.selectedValue == "-1") {
      if (this.interestStatus == "1") {
        this.changeInterestStatus("1");
      } else if (this.interestStatus == "2") {
        this.changeInterestStatus("2");
      }
    }
  }

  changeInterestStatus(status: any) {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.fromDate.setDate(this.fromDate.getDate() - 90);
    this.processType = 1;
    this.selectedValue = "-1";
    this.interestStatus = status;
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (this.interestStatus == "1") {
      this.apiservice.getAllEnrollInterestByEntityId(
        this.entityHash,
        this.interestStatus,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.pageNo.toString(),
        this.interestType
      );
    } else if (this.interestStatus == "2") {
      if (this.bookingType == "4") {
        this.apiservice.getEntityEnquiryList(
          this.entityHash,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          "3"
        );
      } else {
        this.apiservice.getEntityEnquiryList(
          this.entityHash,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.bookingType
        );
      }
    }
  }
  viewDetails(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id },
    });
  }

  addReply(rowvalue: any) {
    let dialogRef = this.dialog.open(UpdateInterestStatusReplyComponent, {
      width: "500px",
      data: {
        data: rowvalue,
        entityHash: this.entityHash,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.apiservice.getAllEnrollInterestByEntityId(
          this.entityHash,
          this.interestStatus,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          this.interestType
        );
      }
    });
  }

  deleteQuery(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this query?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityRequestData(obj);
      }
    });
  }

  addjoiningquery() {
    this.dialog.open(AddJoiningQueryComponent, {
      width: "600px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  onSearch() {
    const fromDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);
    const maxRange = 90;
    const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
    console.log(range);

    if (parseInt(range.toString()) > maxRange) {
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
        data: {
          title: "Alert",
          message:
            "The selected time frame between from date and to date should be under 90 days.",
          okbtn: "Ok",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      return;
    }

    this.loader = true;
    this.loaderservice.showLoader = true;
    if (this.processType == 1) {
      if (this.interestStatus == "1") {
        this.apiservice.getAllEnrollInterestByEntityId(
          this.entityHash,
          this.interestStatus,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          this.interestType
        );
      } else if (this.interestStatus == "2") {
        if (this.bookingType == "4") {
          this.apiservice.getEntityEnquiryList(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            "3"
          );
        } else {
          this.apiservice.getEntityEnquiryList(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            this.bookingType
          );
        }
      }
    } else if (this.processType == 3) {
      if (this.selectedValue == "2") {
        this.apiservice.getHistoricBookingListForFitnessEntity(
          this.entityHash,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.selectedValue == "3") {
        this.apiservice.getHistoricAttendanceListForFitnessEntity(
          this.entityHash,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
    }
  }

  addNewInterest() {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(AddJoiningInterestComponent, {
      width: "750px",
      data: {
        title: "New query",
        ref: this.dialog,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.loader = true;
        this.processType = 1;
        this.selectedValue = "-1";
        this.interestStatus = "1";
        this.loaderservice.showLoader = true;
        this.apiservice.getAllEnrollInterestByEntityId(
          this.entityHash,
          this.interestStatus,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          this.interestType
        );
      }
    });
  }
  addNewInterestFromList() {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      // serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(AddJoiningInterestFromListComponent, {
      width: "750px",
      data: {
        title: "New query",
        ref: this.dialog,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.changeInterestStatus("1");
      }
    });
  }

  createInvoice() {
    let data = {
      entityHash: this.entityHash,
      serviceType: this.interestType,
      // discountInfo: this.discountInfo
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }

  createInvoiceForEnrolled(item: any) {
    let data = {
      entityHash: this.entityHash,
      serviceType: this.interestType,
      enrolledData: item,
      // discountInfo: this.discountInfo
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }
  currentStatusOfChange: any;
  currentMemberOfChange: any;
  changeRequestStatus(item: any, status: any) {
    let statusMessage = "";
    if (status == 1) {
      statusMessage = "Are you sure want to mark the query as new?";
    } else if (status == 2) {
      statusMessage = "Are you sure want to mark the query as in-progress?";
    } else if (status == 3) {
      statusMessage = "Are you sure want to mark the person as enrolled?";
    } else if (status == 4) {
      statusMessage = "Are you sure want to mark the query as cancelled?";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message: statusMessage,
        cancelbtn: "Cancel",
        okbtn: "Confirm",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.currentStatusOfChange = status;
        this.currentMemberOfChange = item;
        let obj = {
          hash_id: item.hash_id,
          entity_hash: this.entityHash,
          status: status,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.updateEnrollInterestProgressStatus(obj);
      }
    });
  }

  addAsMember(item: any) {
    let data = {
      entityHash: this.entityHash,
      eph: this.entityHash,
      memberData: item,
      // serviceType: this.interestType,
    };

    let dialogref = this.dialog.open(AddMemberComponent, {
      width: "650px",
      data: {
        title: "Add member",
        ref: this.dialog,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 0) {
          if (res.whatsapp_share == 0 && res.email_share == 1) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 1 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 0 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          }
          this.loaderservice.showLoader = true;
          this.apiservice.getAllEnrollInterestByEntityId(
            this.entityHash,
            this.interestStatus,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            this.pageNo.toString(),
            this.interestType
          );
        }
      }
    });
  }
  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  formatTimeForBooking(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTime(item.start_time);
        const endTime = this.formatTime(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  // BOOKING OPERATIONS

  changeChip(value: string) {
    this.selectedValue = value;
    // this.loader = true
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (value == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.toDate.getDate() + 90);
      this.processType = 3;

      this.apiservice.getHistoricBookingListForFitnessEntity(
        this.entityHash,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (value == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      // this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.processType = 3;

      this.apiservice.getHistoricAttendanceListForFitnessEntity(
        this.entityHash,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else {
      this.processType = 2;
      if (value == "0") {
        this.apiservice.getBookingsForFitnessEntity(
          this.entityHash,
          this.formatDateForApi(new Date()),
          this.bookingType
        );
      } else if (value == "1") {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.apiservice.getBookingsForFitnessEntity(
          this.entityHash,
          this.formatDateForApi(new Date(tomorrow)),
          this.bookingType
        );
      }
    }
  }

  viewDetailsForMember(item: any) {
    // let data = {
    //   data: item,
    // }
    // this.dialogService.openFullScreenDialog(BookingDetailsForMemberComponent,data);
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  formatDateForApi(dateStr: Date) {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = dateStr
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;

    // // Split the date string by `/`
    // const parts = dateStr.split('/');

    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');

    // // Return the formatted date string
    // return newDateStr;
  }

  startProcess(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 3,
        startTime: this.formatTimeForBooking(new Date()),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }
  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }
  cancelBooking(item: any) {
    // if(confirm("Are you sure you want to cancel this booking?")){

    // let data = {
    //   bookingStatusInfo: {
    //     appointmentHash: item.hash_id,
    //     bookingStatus: 8,
    //   }
    // }

    // console.log(data);
    // this.loaderservice.showLoader = true
    // this.apiservice.updateBookingStatus(data)
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customer_phone,
                customerName: item.customer_name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this.apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }

  done(item: any) {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      serviceType: this.bookingType,
      bookingData: item,
      discountInfo: this.discountInfo,
    };
    this.dialog.open(ManageBookingComponent, {
      width: "700px",
      data: {
        title: "Manage Booking",
        ref: this.dialog,
        data: data,
      },
    });
  }

  assignJob(item: any) {
    this.dialog.open(AssignJobComponent, {
      width: "800px",
      data: {
        title: "Assign job",
        ref: this.dialog,
        data: item,
      },
    });
  }
  assignJobForMember(item: any) {
    this.dialog.open(AssignJobForMembersComponent, {
      width: "800px",
      data: {
        title: "Assign job",
        ref: this.dialog,
        data: item,
      },
    });
  }

  reset(item: any) {
    // if(confirm("This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?")){
    //   let data =  {
    //     appointmentHashId: item.hash_id
    //   }
    //   this.loaderservice.showLoader = true
    //   this.apiservice.resetBookingDetails(data)
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      maxWidth: "700px",
      data: {
        title: "Alert",
        message:
          "This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          appointmentHashId: item.hash_id,
        };
        this.loaderservice.showLoader = true;
        this.apiservice.resetBookingDetails(data);
      }
    });
  }

  openInvoice(item: any) {
    this.dialog.open(InvoiceComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this.dialog,
        showmerge: 1,
        data: item.hash_id,
      },
    });
  }
  bookingDetails(item: any) {
    // this.dialog.open(BookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this.dialog,
    //     data: item
    //   },
    // });
    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: { bookingHash: item.hash_id, merge: "1" },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash_id,
          isf: this.selectedValue,
          bd: item.bookingDate,
        },
      });
    }
  }

  customiseBooking(item: any) {
    this.loaderservice.showLoader = true;
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      serviceType: this.bookingType,
      bookingData: item,
      discountInfo: this.discountInfo,
    };
    this.dialog.open(CustomiseBookingComponent, {
      width: "700px",
      data: {
        title: "Edit Booking Operation",
        ref: this.dialog,
        data: data,
      },
    });
  }

  deleteBooking(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  createNewBooking() {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      serviceType: this.bookingType,
      discountInfo: this.discountInfo,
      isForTomorrow:
        this.selectedValue == "1" && this.processType == 2 ? "1" : "0",
    };

    let dialogref = this.dialog.open(CreateNewBookingComponent, {
      width: "750px",
      data: {
        title: "New Booking",
        ref: this.dialog,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.selectedBookingType == 4) {
          this.loader = true;
          this.changeChip("1");
        } else if (res.selectedBookingType == 5) {
          this._snackBar.open("Booking created successfully", "Ok", {
            duration: 3000,
          });
          // const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          //   width: "500px",
          //   data: {
          //     title: "Booking done!",
          //     message:
          //       "A new booking created successfully in " +
          //       localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME) +
          //       " at " +
          //       this.convertTime24to12(
          //         res.bookingData.bookingStatusInfo.startTime
          //       ) +
          //       " - " +
          //       this.convertTime24to12(res.bookingData.bookingStatusInfo.endTime) +
          //       "  slot on " +
          //       this.formatDate(
          //         res.bookingData.bookingStatusInfo.bookingDate.split(" ")[0]
          //       ) +
          //       ".",
          //     cancelbtn: "Continue",
          //     okbtn: "See the list",
          //     type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          //   },
          //   disableClose: true,
          // });
          // dialogRef.afterClosed().subscribe((result) => {
          //   console.log(result);
          //   if (result) {

          //     this.router.navigate(["/businesses/details/booking-history"], {queryParams: {entityHash: this.entityHash}});
          //   }
          // });
        } else {
          this.loader = true;
          this.changeChip("0");
        }
      }
    });
  }

  createNewBookingFromList() {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      // serviceType: this.bookingType,
      discountInfo: this.discountInfo,
      // isForTomorrow: this.selectedValue,
    };

    let dialogref = this.dialog.open(CreateNewBookingFromListComponent, {
      width: "750px",
      data: {
        title: "New Booking",
        ref: this.dialog,
        data: data,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        this.changeChip("2");
      }
    });
  }

  sortObjectsDescendingByBookingNumber(array: any) {
    return array
      .slice()
      .sort(
        (a: any, b: any) =>
          parseInt(b.appointment_no) - parseInt(a.appointment_no)
      );
  }

  formatDate(dateTime: any) {
    // Create a new Date object from the input string
    console.log(dateTime);

    const date = new Date(dateTime);

    // Define arrays for month names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get day, month, and year from the Date object
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Return the formatted date
    return `${day} ${month} ${year}`;
  }

  convertTime24to12(time: any) {
    // Split the time into hours and minutes
    let [hours, minutes] = time.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12 || 12; // Converts 0 to 12 for midnight and 12-hour format

    // Format hours and minutes to always be two digits
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;

    return formattedTime;
  }

  // BOOKING HISTORY
  bookingDetailsForHistory(item: any) {
    // this.dialog.open(BookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this.dialog,
    //     data: item
    //   },
    // });
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { bookingHash: item.hash_id },
    });
  }

  confirmBookingForHistory(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customerInfo.phone,
        customerName: item.customerInfo.name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }

  cancelBookingForHistory(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customerInfo.phone,
                customerName: item.customerInfo.name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this.apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }
  openInvoiceForHistory(item: any) {
    this.dialog.open(InvoiceForReportComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this.dialog,
        data: item.hash_id,
      },
    });
  }

  deleteBookingForHistory(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  changeAttendanceStatus(status: any, item: any) {
    console.log(item);

    let msg = "";
    if (status == 0) {
      msg = "Are you sure you want to mark this appointment as absent?";
    } else if (status == 1) {
      msg = "Are you sure you want to mark this appointment as present?";
    }
    const dialogRef = this.dialog.open(AttendanceMarkerComponent, {
      data: {
        title: "Alert",
        message: msg,
        status: status,
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          hash_id: item.hash_id, // only while updating the attendance status
          entity_hash: item.entityHash,
          member_hash: item.member_hash_id,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          attendance_status: status, //0-absent,1-present
          notes: result.note,
          attendance_date: this.formatDateForApi(new Date()),
        };

        Object.keys(data).forEach((key) => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });

        console.log(data);

        this.loaderservice.showLoader = true;
        this.apiservice.markMemberAttendanceStatus(data);
      }
    });
  }
  deleteAttendance(rowvalue: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this member's attendance?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          entityHash: rowvalue.entityHash,
          memberHash: rowvalue.member_hash_id
            ? rowvalue.member_hash_id
            : rowvalue.member_hash,
          attendanceHash: rowvalue.hash_id,
        };

        console.log(data);
        this.loaderservice.showLoader = true;
        this.apiservice.deleteMemberAttendanceDataByEntity(data);
      }
    });
  }

  operationForMember(item: any, status: any) {
    this.loaderservice.showLoader = true;
    if (status == 2) {
      let obj = {
        memberHash: item.member_hash_id,
        entityHash: item.entityHash,
        employeeHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        assignByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        sessionStatus: status,
        startTime: this.formatTimeForTime(new Date()),
        endTime: this.addOneHour(this.formatTimeForTime(new Date())),
        attendanceHash: item.hash_id,
      };

      this.apiservice.UpdateMemberSession(obj);
    }
    if (status == 3) {
      let obj = {
        memberHash: item.member_hash_id,
        entityHash: item.entityHash,
        employeeHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        assignByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        sessionStatus: status,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: this.formatTimeForTime(new Date()),
        attendanceHash: item.hash_id,
      };

      this.apiservice.UpdateMemberSession(obj);
    }
  }

  formatTimeForTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.newquerysubscription) {
      this.newquerysubscription.unsubscribe();
    }
    if (this.querystatuschangedsubscription) {
      this.querystatuschangedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                if (this.interestType == "4") {
                  this.changeChip("2");
                } else {
                  if (this.selectedValue == "-1") {
                    this.changeChip("0");
                  } else {
                    this.changeChip(this.selectedValue);
                  }
                }
              };
              if (this.interestType == "4") {
                if (this.selectedValue == "2") {
                  // this.changeChip("2");
                }
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }

              // snackBarRef.afterDismissed().subscribe(() => {
              //   console.log('Snackbar dismissed');
              // });

              // snackBarRef.onAction().subscribe(() => {
              //   console.log('Snackbar action triggered');
              // });
            });
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                if (this.interestType == "4") {
                  this.changeChip("2");
                } else {
                  if (this.selectedValue == "-1") {
                    this.changeChip("0");
                  } else {
                    this.changeChip(this.selectedValue);
                  }
                }
              };
              if (this.interestType == "4") {
                if (this.selectedValue == "2") {
                  this.changeChip("2");
                }
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }

              // snackBarRef.afterDismissed().subscribe(() => {
              //   console.log('Snackbar dismissed');
              // });

              // snackBarRef.onAction().subscribe(() => {
              //   console.log('Snackbar action triggered');
              // });
            });
          }
        }
      });
  }

  private newquerysubscription: Subscription = new Subscription();
  listenForNewQueries() {
    this.newquerysubscription = this.notificationService
      .getNotificationByType("newJoiningQuery")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                this.changeInterestStatus("1");
              };
              if (this.interestType == "4") {
                if (this.interestStatus == "1" && this.processType == 1) {
                  this.changeInterestStatus("1");
                }
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }
            });
          }
        }
      });
  }
  private querystatuschangedsubscription: Subscription = new Subscription();
  listenForNewQueriesStatusUpdate() {
    this.querystatuschangedsubscription = this.notificationService
      .getNotificationByType("membershipQueryStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                this.changeInterestStatus("1");
              };
              if (this.interestType == "4") {
                if (this.interestStatus == "1" && this.processType == 1) {
                  this.changeInterestStatus("1");
                }
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              }
            });
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        console.log("New notification received:", payload);
        if (true) {
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                this.changeChip("0");
              };
              if (this.interestType == "4") {
                this.changeChip("2");

                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }
            });
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        console.log("New notification received:", payload);
        if (true) {
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                this.changeChip("0");
              };
              if (this.interestType == "4") {
                this.changeChip("2");

                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }
            });
          }
        }
      });
  }
  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.entityHash ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              const onRefresh = () => {
                if (this.interestType == "4") {
                  this.changeChip("2");
                } else {
                  if (this.selectedValue == "-1") {
                    this.changeChip("0");
                  } else {
                    this.changeChip(this.selectedValue);
                  }
                }
              };
              if (this.interestType == "4") {
                if (this.selectedValue == "2") {
                  this.changeChip("2");
                }
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message },
                    panelClass: "custom-class1",
                  }
                );
              } else {
                const snackBarRef = this._snackBar.openFromComponent(
                  CustomSnackbarComponent,
                  {
                    duration: 5000, // Adjust duration as needed
                    horizontalPosition: "center",
                    verticalPosition: "top",
                    data: { title, message, onRefresh },
                    panelClass: "custom-class1",
                  }
                );
              }
            });
          }
        }
      });
  }

  addEditMeetingData(item: any) {
    let dialogref = this.dialog.open(MeetingDataForAppointmentComponent, {
      width: "500px",
      data: {
        data: item,
      },
    });
    dialogref.afterClosed().subscribe((data) => {
      if (data) {
        if (this.processType == 2) {
          if (this.selectedValue == "0") {
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date()),
              this.bookingType
            );
          } else if (this.selectedValue == "1") {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.apiservice.getBookingsForFitnessEntity(
              this.entityHash,
              this.formatDateForApi(new Date(tomorrow)),
              this.bookingType
            );
          }
        } else if (this.processType == 3) {
          this.apiservice.getHistoricBookingListForFitnessEntity(
            this.entityHash,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
    });
  }

  addOneHour(timeStr: any) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    // Add one hour
    date.setHours(date.getHours() + 1);

    // Format back to HH:mm
    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  }

  // NEW CODE FOR ROW CLICK
  rowClickHandler = (row: any) => {
    this.viewDetails(row);
  };
  rowClickHandlerForTT = (row: any) => {
    this.bookingDetails(row);
  };

  rowClickHandlerforservicequery = (row: any) => {
    this.viewDetailsforservicequery(row);
  };

  viewDetailsforservicequery(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["service-query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id, serviceType: this.bookingType },
    });
  }
}
